import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

/**
 * GlossaryDetailsLoader
 *  - Display loader when details api is loading
 */
export function GlossaryDetailsLoader(props) {
  return (
    <ContentLoader
      speed={2}
      className={props.className}
      viewBox='0 0 536 399'
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'>
      <path d='M 0 0 h 536 v 210 H 0 V 0 z m 0 229 h 174 v 20 H 0 v -20 z m 417 34 H 0 v 16 h 417 v -16 z M 0 293 h 445 v 16 H 0 v -16 z m 429 30 H 0 v 16 h 429 v -16 z M 0 353 h 445 v 16 H 0 v -16 z m 174 30 H 0 v 16 h 174 v -16 z' />
    </ContentLoader>
  );
}

GlossaryDetailsLoader.propTypes = {
  /**
   * Custom classname to setfor the loader
   */
  className: PropTypes.string.isRequired,
};

GlossaryDetailsLoader.defaultProps = {
  className: '',
};
